module.exports = __webpack_public_path__ + "media/video-y-fotografia-subacuatica_reel.26b1dfb2.mp4";